/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ActurisActivatedEnum;

(function (ActurisActivatedEnum) {
  ActurisActivatedEnum["NO"] = "no";
  ActurisActivatedEnum["IN_PROGRESS"] = "in_progress";
  ActurisActivatedEnum["YES"] = "yes";
})(ActurisActivatedEnum || (ActurisActivatedEnum = {}));